module.exports = __webpack_public_path__ + "Tinebase/js/ace-assembly_x86-FAT.js";